export class ApiResponse<T> {
  success: boolean;
  data?: T | null;
  error?: unknown;
  page?: {
    limit: number;
    skip: number;
    total: number;
  };

  constructor(
    _success: boolean,
    _data?: T,
    _error?: unknown,
    _page?: { limit: number; skip: number; total: number }
  ) {
    this.success = _success;
    this.data = _data ?? null;
    this.error = _error ?? null;
    this.page = _page ?? null;
  }
}
